import { type FC, type ReactNode } from 'react';

// MUI
import { createTheme, ThemeProvider } from '@mui/material';

// screen
import FontFamilyToPrint from 'modules/map/components/pdf-print-form/styled-components/FontFamilyToPrint';

/**
 * Component này đảm bảo việc các mẫu in pdf luôn hiển thị với light mode
 */
const PrintThemeWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const lightTheme = createTheme({
    palette: { mode: 'light' },
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <FontFamilyToPrint />
      {children}
    </ThemeProvider>
  );
};

export default PrintThemeWrapper;
